import React from "react";
import { Button, ButtonGroup, Modal } from "../../components/ui";

// Shown when a user tries to re-activate a SOLD listing card. A sold listing
// can't be reactivated in place — the user either duplicates it (YES) to relist
// the same watch under a new listing ID, or backs out (NO).
const DuplicateListingModal = ({ isOpen, busy, onYes, onNo }) => (
  <Modal
    open={isOpen}
    onClose={onNo}
    variant="dialog"
    size="sm"
    title="Would you like to duplicate this listing?"
    footer={
      <ButtonGroup align="end">
        <Button variant="secondary" data-btn="listing-duplicate-cancel" onClick={onNo} disabled={busy}>
          No
        </Button>
        <Button variant="primary" data-btn="listing-duplicate" onClick={onYes} disabled={busy}>
          {busy ? "Duplicating…" : "Yes"}
        </Button>
      </ButtonGroup>
    }
  >
    This listing has been sold, so it can’t be made active again. Duplicating it
    creates a new listing (with a new listing ID) as an inactive draft that you can
    review and activate.
  </Modal>
);

export default DuplicateListingModal;
